module.exports = __webpack_public_path__ + "static/media/photo80.20f05cfd.jpg";